import { Pipe, PipeTransform } from '@angular/core';

// this pipe will call the function only once instead of calling it each time change detection happens
@Pipe({
  name: 'invoke',
  pure: true
})
export class InvokePipe<T> implements PipeTransform {
  transform(item: T, fn: (x: T) => any): any {
    if (typeof fn !== 'function') {
      return item;
    }
    return fn(item);
  }
}
